import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { trackEvent, trackPage } from './tracking.actions';
import {
  ITrackingProperties,
  ITrackingAction,
  ITrackingObject,
  TrackingScreenNamesEnum,
} from './tracking.data';

@Injectable()
export class TrackingDispatcher {
  constructor(private _store: Store<any>) {}

  trackPage(
    trackingScreenName: TrackingScreenNamesEnum,
    properties?: ITrackingProperties
  ) {
    this._store.dispatch(trackPage(trackingScreenName, properties));
  }

  trackEvent(
    trackingObjects: ITrackingObject | ITrackingObject[],
    trackingAction: ITrackingAction,
    additionalProperties?: any
  ) {
    this._store.dispatch(
      trackEvent(trackingObjects, trackingAction, additionalProperties)
    );
  }
}
